export const isMobileDevice = (): boolean => {
  // Check if user agent contains mobile device identifiers
  const hasMobileUserAgent =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );

  // Check if it's specifically a mobile phone (not a tablet)
  const isMobilePhone = /Mobi/i.test(navigator.userAgent);

  // Check if it's a tablet (iPad, Android tablet)
  const isTablet = /iPad|Tablet|Android(?!.*Mobile)/i.test(navigator.userAgent);

  // Consider it a mobile device if it's either a mobile phone or a tablet
  return hasMobileUserAgent && (isMobilePhone || isTablet);
};
